<template>
  <div v-if="panchVideoUrl" class="w-full  mx-0 px-0md:px-10 overflow-hidden">
    <iframe
        class="w-full my-auto overflow-hidden aspect-[1/1.3]"
        :src="panchVideoUrl"
    ></iframe>
  </div>
  <div v-else @click="startAnimation" class="w-full">
    <img
      v-for="imageIdx in imageList"
      :key="imageIdx"
      :id="'animation-' + imageIdx"
      alt=""
      :src="
        host +
        '/img/diamonds/360/rubin-diamond-' +
        diamondForm.toLowerCase() +
        '-' +
        imageIdx +
        '.jpg'
      "
      :class="{
        block: parseInt(imageIdx) === curImageIdx,
        hidden: parseInt(imageIdx) !== curImageIdx,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, onUnmounted, watch} from "vue";
import { PanchImages } from '@/assets/ts/PanchImages';

const props = defineProps<{
  certificate?: string;
  image_url?: string;
  diamondForm: string;
}>();

const host = process.env.VUE_APP_HOST || "";
const imageFirstId = 1;
const imageLastId = 30;
const curImageIdx = ref(imageFirstId);

const imageList = computed(() => {
  const imageList: string[] = [];

  for (let imageIdx = imageFirstId; imageIdx <= imageLastId; imageIdx++) {
    imageList.push(imageIdx.toString().padStart(3, "0"));
  }

  return imageList;
});

const setCurrentImageIdx = () => {
  if (curImageIdx.value >= imageLastId) {
    curImageIdx.value = imageFirstId;
  } else {
    curImageIdx.value++;
  }
};

const intervalId = ref();
const startAnimation = () => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = false;
  } else {
    intervalId.value = setInterval(setCurrentImageIdx, 150);
  }
};

onMounted(() => {
  checkPanchImage();
  startAnimation();
});

onUnmounted(() => {
  clearInterval(intervalId.value);
  intervalId.value = false;
});

const panchImageUrl = ref('');
const panchVideoUrl = ref('');

const checkPanchImage = async () => {
  if (!props.image_url && props.certificate) {
    const panch = new PanchImages();
    panchImageUrl.value = (await panch.getStill(props.certificate)) as string;

    if (panchImageUrl.value != "") {
      panchVideoUrl.value = panch.get360(props.certificate)
    }

  } else {
    panchImageUrl.value = '';
  }
};

watch(() => props.certificate, checkPanchImage, { deep: true });

</script>

<style></style>
